import { Component, Input } from '@angular/core';
import { PROJECT_STATUS_LABELS } from 'src/app/maintenance-user/enums/project-statatus.enum';

@Component({
  selector: 'app-projects-template',
  templateUrl: './projects-template.component.html',
  standalone: false,
})
export class ProjectsTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };

  PROJECT_STATUS_LABELS = PROJECT_STATUS_LABELS;
}
